<template>
  <div>
    <van-nav-bar
      title="我的订单"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />

    <van-cell :value="item.clientname" is-link v-for="item in orderdata" @click="todetail(item.id)" :key="item.id">
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">订单ID:{{item.id}}</span>
        <van-tag type="default" v-if="item.status==0">状态:未发布</van-tag>
        <van-tag type="warning" v-if="item.status==1">状态:等待调货</van-tag>
        <van-tag type="info" v-if="item.status==2">状态:等待发货</van-tag>
        <van-tag type="primary" v-if="item.status==3">状态:发货完成</van-tag>
        <van-tag type="danger" v-if="item.status==4">状态:待审核</van-tag>
      </template>
    </van-cell>



  </div>
</template>

<script>
  import * as Api from './api.js'

  export default {
    name: 'getmyorder',
    data () {
      return {
        value:'',
        orderdata:[],



      }
    },
    created() {
       this.$store.dispatch('getlocaluserinfo').then(xx=>{
         this.getorder()
       })

    },
    methods:{
      getorder(){
        let query = {
          saler:this.$store.state.userinfo.userId,
          ordering:'-id',
          limit:999
        }
        Api.getorders(query).then(res=>{
          console.log(res)
          this.orderdata = res.data.data
        })
      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      todetail(id){
        this.$router.push({path:'/salerviews/orderdetail',query:{id:id}})
      }

    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/salerviews/myorder/index.vue